import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { BUSINESS } from "@/lib/constants";

export const CtaStrip = () => {
    return (
        <section data-testid="cta-strip" className="bg-[#F3F1EA]">
            <div className="container-prose py-20">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
                    <div className="lg:col-span-8">
                        <div className="overline">Ready when you are</div>
                        <h2 className="mt-3 font-serif text-3xl sm:text-4xl md:text-5xl tracking-tight leading-[1.05] text-[#1A362B] font-medium">
                            Let's tailor the right finance solution for you.
                        </h2>
                    </div>
                    <div className="lg:col-span-4 flex flex-col sm:flex-row lg:flex-col gap-3">
                        <Link to="/contact" data-testid="cta-strip-primary" className="btn-primary">
                            Book consultation <ArrowRight className="w-4 h-4" />
                        </Link>
                        <a href={`tel:${BUSINESS.phoneTel}`} data-testid="cta-strip-call" className="btn-outline">
                            <Phone className="w-4 h-4" /> {BUSINESS.phone}
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CtaStrip;
